/** @jsx jsx */
import { Fragment } from "react"
import { jsx } from "theme-ui"

import { vwoService } from "@trueskin-web/services"

import homeFilledSvg from "./homeFilledIcon.svg"

export const homeFilledIcon = vwoService.isThemeRebrandedEnabled()
  ? homeFilledSvg
  : {
      path: (
        <path
          d="M12 1L2 8.15909V22H8.19048V13.8864H15.8095V22H22V8.15909L12 1Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ),
      viewBox: "0 0 24 24",
    }
